module.exports = __webpack_public_path__ + "img/google-drive.0b731a3.jpg";